import { useState } from "react";
import { Identifiable, NamedIdentifiable } from "../../model/Items";
import DataPanel from "../DataPanel";
import { MaterialPricesPanelProperties } from "./PricingsPanel";
import SpringMaterialPriceDetails from "./SpringMaterialPriceDetails";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import useSpringMaterialApi from "../../api/SpringMaterialApi";

interface SpringMaterialBusinessIdentifiable
extends NamedIdentifiable {
  thickness: number;
}

interface SpringMaterialPrice
extends Identifiable {
  material: SpringMaterialBusinessIdentifiable;
  unitPrice: number;
}

const springMaterialPricesColumns = [
  {
    name: 'material',
    label: 'Materiał',
  },
  {
    name: 'unitPrice',
    label: 'Cena',
  }
];

const convertToSpringMaterialPriceRow = (data: SpringMaterialPrice) => ({
  id: data.id,
  material: `${data.material.name} (${data.material.thickness} mm)`,
  unitPrice: data.unitPrice
});

const SpringMaterialPricesPanel = (properties: MaterialPricesPanelProperties) => {
  const springMaterialApi = useSpringMaterialApi();
  const customerId = properties.customerId;
  const priceListId = properties.priceListId;

  const [pocketSpringMaterialPricesAccordionExpanded, setPocketSpringMaterialPricesAccordionExpanded] = useState<boolean>(true);
  const [bonnellSpringMaterialPricesAccordionExpanded, setBonnellSpringMaterialPricesAccordionExpanded] = useState<boolean>(true);

  const handleBonnellSpringMaterialPricesAccordionChanged = (expanded: boolean) =>
    setBonnellSpringMaterialPricesAccordionExpanded(expanded);

  const handlePocketSpringMaterialPricesAccordionChanged = (expanded: boolean) =>
    setPocketSpringMaterialPricesAccordionExpanded(expanded);

  return <>
    <Accordion
        expanded={ bonnellSpringMaterialPricesAccordionExpanded }
        onChange={ (event, expanded) => handleBonnellSpringMaterialPricesAccordionChanged(expanded) }
    >
      <AccordionSummary>{bonnellSpringMaterialPricesAccordionExpanded ? 'Zwiń' : 'Rozwiń'} cennik sprężyn Bonnell</AccordionSummary>
      <AccordionDetails>
        <DataPanel
          title='Cennik sprężyn Bonnell'
          resource={ `customers/${customerId}/price-lists/${priceListId}/bonnell-spring-material-prices` }
          columns={ springMaterialPricesColumns }
          selectableRows='multiple'
          renderDetails={(detailsProps) => <SpringMaterialPriceDetails
            { ...detailsProps }
            customerId={ customerId }
            priceListId={ priceListId }
            fetchSpringMaterials={ springMaterialApi.fetchBonnellSpringMaterials }
          />}
          convert={ convertToSpringMaterialPriceRow }
        />
      </AccordionDetails>
    </Accordion>
    <Accordion
        expanded={ pocketSpringMaterialPricesAccordionExpanded }
        onChange={ (event, expanded) => handlePocketSpringMaterialPricesAccordionChanged(expanded) }
    >
      <AccordionSummary>{pocketSpringMaterialPricesAccordionExpanded ? 'Zwiń' : 'Rozwiń'} cennik sprężyn Pocket</AccordionSummary>
      <AccordionDetails>
        <DataPanel
          title='Cennik sprężyn Pocket'
          resource={ `customers/${customerId}/price-lists/${priceListId}/pocket-spring-material-prices` }
          columns={ springMaterialPricesColumns }
          selectableRows='multiple'
          renderDetails={(detailsProps) => <SpringMaterialPriceDetails
            { ...detailsProps}
            customerId={ customerId }
            priceListId={ priceListId }
            fetchSpringMaterials={ springMaterialApi.fetchPocketSpringMaterials }
          />}
          convert={ convertToSpringMaterialPriceRow }
        />
      </AccordionDetails>
    </Accordion>
  </>
}
export default SpringMaterialPricesPanel;